
import * as FormatUtils from "../utils/format"
import i18next from '../i18n'




export const getChartsOptions = (interests?: any | [], label?: string, isPercent?: boolean) => {
  return {
    scaleOverride: true,
    scaleSteps: 10,
    scaleStepWidth: 50,
    scaleStartValue: 0,
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        intersect: false,
        titleFont: {
          size: 16
        },
        bodyFont: {
          size: 17
        },
        callbacks: {
          label: function (context: any) {
            return `${context.dataset.label}: ${FormatUtils.currency.format(+context.dataset.data[context.dataIndex])}`;
          },
          afterLabel: function (context: any) {
            let data = interests[context.dataIndex];
            return (
              `${label || i18next.t('unrealisedInterest')}:  ${(isPercent ? +data * 100 : FormatUtils.currency.format(data))} ${isPercent ? '%' : ''}`
            );
          }
        },
      },
    },
    scales: {
      x: {
        ticks: {
          font: getAxesSizes,
        },
        grid: {
          display: false
        }
      },
      y: {
        ticks: {
          beginAtZero: false,
          suggestedMin: 0,
          suggestedMax: 420,
          font: getAxesSizes
        }
      }
    },
    elements: {
      point: {
        radius: 0
      }
    }
  }
}


const getAxesSizes = function (context: any) {
  var width = context.chart.width;
  var value = Math.round(width / 35);
  const size = value < 16 ? value : 15;
  return {
    size
  };
}


export const getPieChartsOptions = (interests?: any | []) => {
  return {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
      },
      tooltip: {
        enabled: true,
        intersect: false,
        titleFont: {
          size: 16
        },
        bodyFont: {
          size: 16
        },
        callbacks: {
          label: function (context: any) {
            return (
              `${i18next.t('value', { ns: 'products' })}:  ${(+context?.parsed) * 100}%`
            );
          },
          afterLabel: function (context: any) {
            let label = interests[context.dataIndex];
            return (
              i18next.t('isinCode', { ns: 'products' }) + ":  " + label

            );
          }
        },
      },
    },
  }
}


